/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const sourceRowBookingsMin = 0
export const sourceRowBookingsMax = 9007199254740991

export const sourceRowLastBookedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)

export const SourceRow = zod.object({
  bookings: zod.int().min(sourceRowBookingsMin).max(sourceRowBookingsMax),
  lastBookedAt: zod.union([zod.iso.datetime({ offset: true }).regex(sourceRowLastBookedAtOneRegExp), zod.null()]),
  slug: zod.string().nullable(),
  status: zod.enum(['saved', 'unlisted', 'unknown']),
})

export type SourceRow = zod.input<typeof SourceRow>
export type SourceRowOutput = zod.output<typeof SourceRow>
